<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Noty'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <div class="invoice-document-details-view-container" *ngIf="invoiceDocumentObject" fxLayout="column"
         fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px">
        <button
          [disabled]="!(userPermissions | async)?.settlement?.read"
          (click)="downloadPdf()"
          mat-stroked-button
        >
          <mat-icon>download</mat-icon>
          <span> PDF</span>
        </button>

        <button
          *ngIf="isWithoutContract
            && (invoiceDocumentObject?.remainingAmount ?? 0) > 0
            && (userPermissions | async)?.settlement?.create"
          [disabled]="markingPaid"
          (click)="markPaid()"
          mat-stroked-button
          color="primary"
        >
          <mat-icon>check_circle</mat-icon>
          <span> Zapłacona</span>
        </button>

        <button
          *ngIf="(userPermissions | async)?.settlement?.create"
          (click)="delete()"
          mat-stroked-button
          color="warn"
        >
          <mat-icon>delete</mat-icon>
          <span> Usuń</span>
        </button>
      </div>
      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
        <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card>
            <app-section-header
              [title]="'Dane noty: ' + invoiceDocumentObject?.number"
              [description]=null
            ></app-section-header>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
              <app-detail fxFlex="33" header="Kwota">
                {{ (invoiceDocumentObject?.net ?? 0) | number:'1.2-2' }} zł
              </app-detail>

              <app-detail fxFlex="33" header="Odliczono">
                {{ (invoiceDocumentObject?.deductedAmount ?? 0) | number:'1.2-2' }} zł
              </app-detail>

              <app-detail fxFlex="33" header="Pozostało">
                {{ (invoiceDocumentObject?.remainingAmount ?? 0) | number:'1.2-2' }} zł
              </app-detail>
            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data wystawienia">
                {{ invoiceDocumentObject?.issueDate | date:'dd.MM.yyyy' }}
              </app-detail>

              <app-detail fxFlex="50" header="Powód wystawienia">
                {{ invoiceDocumentObject?.reason || '-' }}
              </app-detail>
            </div>
          </mat-card>
        </div>
        <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card>
            <ng-container *ngIf="isWithoutContract; else relations">
              <app-section-header
                [title]="'Dane odbiorcy'"
                [description]=null
              ></app-section-header>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Nazwa firmy / Imię i nazwisko">
                  {{ invoiceDocumentObject?.recipientName || '-' }}
                </app-detail>
              </div>

              <div fxLayout="row">
                <app-detail fxFlex="100" header="Ulica i numery">
                  {{ invoiceDocumentObject?.recipientStreet || '-' }}
                </app-detail>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                <app-detail fxFlex="50" header="Kod pocztowy">
                  {{ invoiceDocumentObject?.recipientZipCode || '-' }}
                </app-detail>

                <app-detail fxFlex="50" header="Poczta">
                  {{ invoiceDocumentObject?.recipientPostOffice || '-' }}
                </app-detail>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                <app-detail fxFlex="50" [header]="invoiceDocumentObject?.recipientNip ? 'NIP' : 'PESEL'">
                  {{ invoiceDocumentObject?.recipientNip || invoiceDocumentObject?.recipientPesel || '-' }}
                </app-detail>

                <app-detail fxFlex="50" header="Firma">
                  {{ invoiceDocumentObject?.company?.name || '-' }}
                </app-detail>
              </div>
            </ng-container>

            <ng-template #relations>
              <app-section-header
                [title]="'Relacje'"
                [description]=null
              ></app-section-header>

              <div fxLayout="row">
                <app-detail
                  fxFlex="100"
                  header="Umowa"
                  [value]="invoiceDocumentObject?.contract
                    ? invoiceDocumentObject.contract.type.name
                      + ' (nr: ' + invoiceDocumentObject.contract.number + '), zawarta '
                      + (invoiceDocumentObject.contract.concludeDate | date:'y-MM-dd')
                    : '-'"
                  [link]="invoiceDocumentObject?.contract
                    ? ['/umowy/szczegoly', invoiceDocumentObject.contract.uuid]
                    : undefined">
                </app-detail>
              </div>

              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
                <app-detail
                  fxFlex="50"
                  header="Partner"
                  [value]="invoiceDocumentObject?.partner?.shortName || '-'"
                  [link]="invoiceDocumentObject?.partner?.uuid
                    ? ['/partnerzy/szczegoly', invoiceDocumentObject.partner.uuid]
                    : undefined">
                </app-detail>

                <app-detail fxFlex="50" header="Firma">
                  {{ invoiceDocumentObject?.company?.name || '-' }}
                </app-detail>
              </div>
            </ng-template>
          </mat-card>
        </div>
      </div>

      <div *ngIf="!isWithoutContract" fxLayout="row" fxFlex="100" fxLayoutGap="15px">
        <mat-card fxFlex="100">
          <app-section-header
            [title]="'Dokumenty księgowe'"
            [description]=null
          ></app-section-header>


          <table mat-table [dataSource]="invoiceDocumentObject?.deductions || []">
            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef>Numer faktury</th>
              <td mat-cell *matCellDef="let row">
                <a class="default-link" [routerLink]="['/faktury/szczegoly', row.invoice?.uuid]">
                  {{ row.invoice?.number || '-' }}
                </a>
              </td>
            </ng-container>

            <ng-container matColumnDef="issueDate">
              <th mat-header-cell *matHeaderCellDef>Data wystawienia faktury</th>
              <td mat-cell *matCellDef="let row">
                {{ row.invoice?.issueDate | date:'dd.MM.yyyy' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status faktury</th>
              <td mat-cell *matCellDef="let row">
                {{ row.invoice?.status?.name || '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="net">
              <th mat-header-cell *matHeaderCellDef>Kwota faktury</th>
              <td mat-cell *matCellDef="let row">
                {{ (row.invoice?.net ?? 0) | number:'1.2-2' }} zł
              </td>
            </ng-container>

            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Potrącono</th>
              <td mat-cell *matCellDef="let row">
                {{ (row.amount ?? 0) | number:'1.2-2' }} zł
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button color="accent" aria-label="" (click)="downloadDeductionPdf(row?.uuid)">
                  <mat-icon>download</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="deductionDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: deductionDisplayedColumns;"></tr>
          </table>

          <div *ngIf="!invoiceDocumentObject?.deductions?.length" class="empty-table">
            Brak dowiązanych dokumentów księgowych.
          </div>
        </mat-card>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
